import { connect } from 'react-redux';
import { IRootState } from '../../../redux/state';
import SmartMapGrid from './smartMapGrid';

function mapStateToProps(state: IRootState) {
  return {
    genericMapRoutes: state.genericMapRoutes.genericMapRoutes,
    agreements: state.genericMapRoutes.genericMapAgreements,
    routeList: state.route.routeList,
    places: state.genericMapRoutes.genericMapPlaces,
    bins: state.genericMapRoutes.genericMapAgreementLines,
    selectedRoutes: state.genericMapRoutes.genericMapRoutes,
    filterType: state.genericMapRoutes.filterType,
  };
}

export default connect(mapStateToProps)(SmartMapGrid);
